import React, { useState } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../../Config";
import { useSelector } from "react-redux";

const LedgerAccountTaxDetails = ({
  ledger_account_id,
  ledgerFormData,
  onValueChange,
  saveAndNext,
  tabId,
  backId,
}) => {

  const {
    MasterAccountTdsCategoryName,
    loadingMasterAccountTdsCategoryName,
  } = useSelector((state) => state?.MasterReducer);

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Basic validation before API call
  const validateTaxDetails = () => {
    // If TDS is applicable = YES → more fields are required
    if (ledgerFormData.tds_applicable === "YES") {
      if (!ledgerFormData.tds_category) {
        toast.error("TDS Category is required when TDS is applicable");
        return false;
      }
      if (!ledgerFormData.tds_percentage || ledgerFormData.tds_percentage <= 0) {
        toast.error("Valid TDS Percentage is required when TDS is applicable");
        return false;
      }
    }
    // if (!ledgerFormData.pan_number?.trim()) {
    //   toast.error("PAN Number is required when TDS is applicable");
    //   return false;
    // }

    // Optional: Always require PAN if you want (uncomment if needed)
    if (!ledgerFormData.pan_number?.trim()) {
      toast.error("PAN Number is required");
      return false;
    }

    return true;
  };

  const submitLedgerForm = async () => {
    // 1. Validate form data first
    if (!validateTaxDetails()) {
      return;
    }

    setIsSubmitting(true);

    const {
      tds_applicable,
      tds_category,
      tds_percentage,
      pan_number
    } = ledgerFormData;



    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/ledger-account`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify({
            ledger_account_id,
            tds_applicable,
            tds_category,
            tds_percentage: tds_percentage ? Number(tds_percentage) : null,
            pan_number: pan_number?.trim() || null,
          }),
        }
      );
      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg || "Tax details updated successfully");
        saveAndNext(tabId);
      } else {
        toast.error(data?.msg || "Failed to update tax details");
        console.error("Error updating tax details:", data.message);
      }
    } catch (error) {
      toast.error("Network error while saving tax details");
      console.error("Network error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>
      <div className="row">
        {/* tds_applicable */}
        <div className="col-md-6 mb-4">
          <label className="form-label fw-medium">TDS Applicable</label>
          <select
            onChange={onValueChange}
            value={ledgerFormData.tds_applicable || ""}
            name="tds_applicable"
            className="form-select bg-light padding-pt-9"
          >
            <option value="">Select TDS Applicable</option>
            <option value="YES">YES</option>
            <option value="NO">NO</option>
          </select>
        </div>

        {/* tds_category */}
        <div className="col-md-6 mb-4">
          <label className="form-label fw-medium">
            TDS Category <span className="text-danger">*</span>
          </label>
          <select
            onChange={onValueChange}
            value={ledgerFormData.tds_category || ""}
            name="tds_category"
            className="form-select bg-light padding-pt-9"
            disabled={
              ledgerFormData.tds_applicable !== "YES" ||
              loadingMasterAccountTdsCategoryName
            }
          >
            <option value="">Select TDS Category</option>
            {MasterAccountTdsCategoryName?.map((item, i) => (
              <option key={i} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        {/* tds_percentage */}
        <div className="col-md-6 mb-4">
          <label className="form-label fw-medium">
            TDS Percentage <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            name="tds_percentage"
            className="form-control bg-light"
            placeholder="e.g. 10.00"
            onChange={onValueChange}
            value={ledgerFormData.tds_percentage || ""}
            disabled={ledgerFormData.tds_applicable !== "YES"}
            min="0"
            max="100"
            step="1"
          />
        </div>

        {/* pan_number */}
        <div className="col-md-6 mb-4">
          <label className="form-label fw-medium">
            Pan Number <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="pan_number"
            className="form-control bg-light"
            placeholder="XXXXX#####X"
            onChange={onValueChange}
            value={ledgerFormData.pan_number || ""}
            // disabled={ledgerFormData.tds_applicable !== "YES"}
            maxLength={10}
          />
        </div>

        {/* ACTION BUTTONS */}
        <div className="d-flex gap-2 mt-3">
          <button
            onClick={() => saveAndNext(backId)}
            className="btn btn-primary border px-4"
            disabled={isSubmitting}
          >
            Back
          </button>
          <button
            onClick={submitLedgerForm}
            className="btn btn-primary px-4"
            disabled={isSubmitting}
          >
            <i className="fas fa-save me-1"></i>
            {isSubmitting ? "Saving..." : "Save & Next"}
          </button>
        </div>
      </div>
    </>
  );
};

export default LedgerAccountTaxDetails;